import React, { useRef, useCallback } from 'react';
import { Bold, Italic, Link, List, Heading2 } from 'lucide-react';

const RichTextEditor = ({ value, onChange, placeholder }) => {
  const textareaRef = useRef(null);

  const insertTag = useCallback((startTag, endTag) => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = value.substring(start, end);
    const newText = value.substring(0, start) + startTag + selectedText + endTag + value.substring(end);
    
    onChange(newText);
    
    // Restore cursor position
    setTimeout(() => {
      textarea.focus();
      const newCursorPos = start + startTag.length + selectedText.length + endTag.length;
      textarea.setSelectionRange(newCursorPos, newCursorPos);
    }, 0);
  }, [value, onChange]);

  const formatBold = () => insertTag('<strong>', '</strong>');
  const formatItalic = () => insertTag('<em>', '</em>');
  const formatHeading = () => insertTag('<h2>', '</h2>');
  const formatList = () => insertTag('<ul>\n  <li>', '</li>\n</ul>');
  
  const formatLink = () => {
    const url = prompt('Entrez l\'URL du lien :');
    if (url) {
      insertTag(`<a href="${url}">`, '</a>');
    }
  };

  return (
    <div className="border border-stone-300 focus-within:border-hermes-600 rounded-sm">
      {/* Toolbar */}
      <div className="flex items-center gap-1 p-2 border-b border-stone-200 bg-stone-50">
        <button
          type="button"
          onClick={formatBold}
          className="p-2 hover:bg-stone-200 rounded transition-colors"
          title="Gras"
        >
          <Bold className="w-4 h-4" />
        </button>
        <button
          type="button"
          onClick={formatItalic}
          className="p-2 hover:bg-stone-200 rounded transition-colors"
          title="Italique"
        >
          <Italic className="w-4 h-4" />
        </button>
        <button
          type="button"
          onClick={formatHeading}
          className="p-2 hover:bg-stone-200 rounded transition-colors"
          title="Titre"
        >
          <Heading2 className="w-4 h-4" />
        </button>
        <button
          type="button"
          onClick={formatList}
          className="p-2 hover:bg-stone-200 rounded transition-colors"
          title="Liste"
        >
          <List className="w-4 h-4" />
        </button>
        <button
          type="button"
          onClick={formatLink}
          className="p-2 hover:bg-stone-200 rounded transition-colors"
          title="Lien"
        >
          <Link className="w-4 h-4" />
        </button>
      </div>
      
      {/* Editor */}
      <textarea
        ref={textareaRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full min-h-[250px] p-4 resize-y focus:outline-none font-mono text-sm"
        data-testid="rich-text-editor"
      />
      
      {/* Preview */}
      {value && (
        <div className="border-t border-stone-200 p-4 bg-stone-50">
          <p className="text-xs text-stone-500 mb-2 font-medium">Aperçu :</p>
          <div 
            className="prose prose-sm prose-stone max-w-none"
            dangerouslySetInnerHTML={{ __html: value }}
          />
        </div>
      )}
    </div>
  );
};

export default RichTextEditor;
